import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { UserUrls } from "../../UserManagement";
import UserParent from "../../UserManagement/UserNew/util/UserParent";
import UserTable from "../../../components/UserTable";

const CompanyUsers = ({
  match: {
    params: { id },
  },
  location: { state },
}: RouteComponentProps<
  { readonly id: string },
  {},
  { readonly name: string }
>) => {
  const { name = "" } = state ?? {};
  return (
    <UserTable
      subtitle={name}
      queryParams={{ organisationType: "Company", organisationId: id }}
      createUrl={UserUrls.create({ [UserParent.COMPANY]: id })}
    />
  );
};

export default CompanyUsers;
